import { nanoid } from 'nanoid';
import { sendSlardarEvent, ECustomEvent } from '@/libs/slardar';

export * from './device';

export function isInPage(node: Node | null) {
  return node === document.body ? false : document.body.contains(node);
}

let intersectionObserver: IntersectionObserver;
export function startVisibleListen(
  el: Element | null,
  cb: (params: IntersectionObserverEntry[]) => void,
) {
  intersectionObserver = new IntersectionObserver(
    entries => {
      cb(entries);
    },
    {
      threshold: 1,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      trackVisibility: true,
      delay: 100,
    },
  );
  // start observing
  if (el) {
    intersectionObserver.observe(el);
  }
}

export function stopVisibleListen() {
  intersectionObserver?.disconnect();
}

export function getDeviceId() {
  try {
    let uuid = localStorage.getItem('_feelgood_uuid_');
    if (uuid) {
      return uuid;
    } else {
      uuid = nanoid();
      localStorage.setItem('_feelgood_uuid_', uuid);
      return uuid;
    }
  } catch (error) {
    const now = new Date();
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
    );
    const timestampId = startOfDay.getTime();
    sendSlardarEvent(ECustomEvent.GetDeviceIdError, {
      categories: {
        error,
        timestampId,
      },
    });
    return timestampId.toString();
  }
}
